import { createTheme } from '@mui/material/styles';
import '@mui/styles';
export var theme = createTheme({ breakpoints: { values: { xs: 500, sm: 700, md: 960, lg: 1280, xl: 1920 } }, palette: { primary: { main: '#834DF0' }, secondary: { main: '#1e1e1e' } } });
